<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <el-menu-item index="1" @click="toNewRouter('fire-over-view')" v-if="permissionCodes.indexOf('021011000') !== -1">
        <i class="el-icon-damai-shujulaiyuan" style="font-size: 16px;"></i>
        <span slot="title">概览</span>
      </el-menu-item>
      <el-submenu index="2" v-if="permissionCodes.indexOf('021001000') !== -1 || permissionCodes.indexOf('021007000') !== -1 || permissionCodes.indexOf('021008000') !== -1 || permissionCodes.indexOf('021002000') !== -1 || permissionCodes.indexOf('021003000') !== -1">
        <template slot="title" >
          <i class="el-icon-damai-shebei2"></i>
          <span>设备管理</span>
        </template>
        <el-menu-item-group>

          <el-submenu index="2-1" v-if="permissionCodes.indexOf('021007000') !== -1 || permissionCodes.indexOf('021008000') !== -1">
            <template slot="title">
              <i class="el-icon-damai-chuanshu"></i>
              <span>用传管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="2-1-1" @click="toNewRouter('transmission-device')" v-if="permissionCodes.indexOf('021007000') !== -1">用传设备</el-menu-item>
              <el-menu-item index="2-1-2" @click="toNewRouter('point-position-device')" v-if="permissionCodes.indexOf('021008000') !== -1">点位设备</el-menu-item>
            </el-menu-item-group>
          </el-submenu>

          <el-submenu index="2-2" v-if="permissionCodes.indexOf('021001000') !== -1 || permissionCodes.indexOf('021002000') !== -1 || permissionCodes.indexOf('021003000') !== -1">
            <template slot="title">
              <i class="el-icon-damai-wangguan"></i>
              <span>网关管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="2-2-1" @click="toNewRouter('gateway-device')" v-if="permissionCodes.indexOf('021001000') !== -1">网关设备</el-menu-item>
              <el-menu-item index="2-2-2" @click="toNewRouter('hydraulic-pressure-manage')" v-if="permissionCodes.indexOf('021002000') !== -1">液位设备</el-menu-item>
              <el-menu-item index="2-2-3" @click="toNewRouter('level-device-manage')" v-if="permissionCodes.indexOf('021003000') !== -1">液压设备</el-menu-item>
            </el-menu-item-group>
          </el-submenu>

        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="3" @click="toNewRouter('fire-control-call-police-record')" v-if="permissionCodes.indexOf('021005000') !== -1">
        <i class="el-icon-damai--baojingjilu"></i>
        <span slot="title">报警记录</span>
      </el-menu-item>
      <el-menu-item index="6" @click="toNewRouter('fire-control-transfer-record')" v-if="permissionCodes.indexOf('021009000') !== -1">
        <i class="el-icon-damai-ic_tiaobanguanli"></i>
        <span slot="title">用传记录</span>
      </el-menu-item>
      <el-menu-item index="4" @click="toNewRouter('fire-control-device-state-record')" v-if="permissionCodes.indexOf('021006000') !== -1">
        <i class="el-icon-damai-zhuangtairizhi"></i>
        <span slot="title">设备状态日志</span>
      </el-menu-item>
      <el-menu-item index="5" @click="toNewRouter('fire-control-log')" v-if="permissionCodes.indexOf('021010000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>

      <!-- <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 25px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div> -->
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  1: "fire-over-view",
  "2-1-1": [
    "transmission-device",
    "transmission-device-add",
    "transmission-device-modify"
  ],
  "2-1-2": [
    "point-position-device",
    "point-position-device-add",
    "point-position-device-modify"
  ],
  "2-2-1": ["gateway-device", "gateway-device-add", "gateway-device-modify"],
  "2-2-2": [
    "hydraulic-pressure-manage",
    "hydraulic-pressure-add",
    "hydraulic-pressure-modify"
  ],
  "2-2-3": ["level-device-manage", "level-device-add", "level-device-modify"],
  3: "fire-control-call-police-record",
  4: "fire-control-device-state-record",
  5: "fire-control-log",
  6: "fire-control-transfer-record"
});

export default {
  name: "phone-service-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    }
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", data => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/FireControl/FireControlNav.vue